// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-switch {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_0-switch[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-switch > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-switch .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-switch-wrapper {
  /* Typography */
  --perxis-auto-switch-font-family-inner: var(
    --perxis-auto-switch-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-switch-font-size-inner: var(
    --perxis-auto-switch-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-switch-font-weight-inner: var(
    --perxis-auto-switch-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-switch-letter-spacing-inner: var(
    --perxis-auto-switch-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-switch-line-height-inner: var(
    --perxis-auto-switch-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-switch-text-transform-inner: var(
    --perxis-auto-switch-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-switch-color-inner: var(
    --perxis-auto-switch-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-switch-loading-color-inner: var(
    --perxis-auto-switch-loading-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-switch-checked-loading-color-inner: var(
    --perxis-auto-switch-checked-loading-color,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-switch-border-color-inner: var(--perxis-auto-switch-border-color, transparent);
  --perxis-auto-switch-hover-border-color-inner: var(
    --perxis-auto-switch-hover-border-color,
    var(--perxis-auto-switch-border-color-inner)
  );
  --perxis-auto-switch-checked-border-color-inner: var(
    --perxis-auto-switch-checked-border-color,
    var(--perxis-auto-switch-border-color-inner)
  );
  --perxis-auto-switch-hover-checked-border-color-inner: var(
    --perxis-auto-switch-hover-checked-border-color,
    var(--perxis-auto-switch-checked-border-color-inner)
  );
  --perxis-auto-switch-background-color-inner: var(
    --perxis-auto-switch-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-switch-hover-background-color-inner: var(
    --perxis-auto-switch-hover-background-color,
    var(--perxis-auto-switch-background-color-inner)
  );
  --perxis-auto-switch-checked-background-color-inner: var(
    --perxis-auto-switch-checked-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-switch-hover-checked-background-color-inner: var(
    --perxis-auto-switch-hover-checked-background-color,
    var(--perxis-auto-switch-checked-background-color-inner)
  );
  --perxis-auto-switch-handle-background-color-inner: var(
    --perxis-auto-switch-handle-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-switch-handle-hover-background-color-inner: var(
    --perxis-auto-switch-handle-hover-background-color,
    var(--perxis-auto-switch-handle-background-color-inner)
  );
  --perxis-auto-switch-handle-checked-background-color-inner: var(
    --perxis-auto-switch-handle-checked-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-switch-handle-border-color-inner: var(
    --perxis-auto-switch-handle-border-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-switch-handle-checked-border-color-inner: var(
    --perxis-auto-switch-handle-checked-border-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-switch-border-radius-inner: var(--perxis-auto-switch-border-radius, 100px);
  --perxis-auto-switch-border-width-inner: var(--perxis-auto-switch-border-width, 2px);
  --perxis-auto-switch-hover-border-width-inner: var(
    --perxis-auto-switch-hover-border-width,
    var(--perxis-auto-switch-border-width-inner)
  );
  --perxis-auto-switch-hover-checked-border-width-inner: var(
    --perxis-auto-switch-hover-checked-border-width,
    var(--perxis-auto-switch-border-width-inner)
  );
  --perxis-auto-switch-handle-border-width-inner: var(--perxis-auto-switch-handle-border-width, 0);
  --perxis-auto-switch-handle-border-radius-inner: var(--perxis-auto-switch-handle-border-radius, 50%);
  /* End Border */
  /* Box Shadow */
  --perxis-auto-switch-handle-box-shadow-inner: var(
    --perxis-auto-switch-handle-box-shadow,
    0px 0px 4px rgba(0, 0, 0, 0.25)
  );
  /* End Box Shadow */
  /* Opacity */
  --perxis-auto-switch-opacity-inner: var(--perxis-auto-switch-opacity, 1);
  --perxis-auto-switch-opacity-disabled-inner: var(--perxis-auto-switch-opacity-disabled, 0.65);
  /* End Opacity */
  /* Padding */
  --perxis-auto-switch-padding-inner: var(--perxis-auto-switch-padding, 0 5px 0 12px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-switch-handle-width-inner: var(--perxis-auto-switch-handle-width, 24px);
  --perxis-auto-switch-handle-height-inner: var(--perxis-auto-switch-handle-height, 24px);
  /* End Sizes */
  display: inline-flex;
  align-items: center;
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch {
  --perxis-auto-switch-width-inner: var(--perxis-auto-switch-width, 54px);
  --perxis-auto-switch-height-inner: var(--perxis-auto-switch-height, 32px);
  background-color: var(--perxis-auto-switch-background-color-inner);
  min-width: var(--perxis-auto-switch-width-inner);
  border-radius: var(--perxis-auto-switch-border-radius-inner);
  border-width: var(--perxis-auto-switch-border-width-inner);
  border-color: var(--perxis-auto-switch-border-color-inner);
  border-style: solid;
  height: var(--perxis-auto-switch-height-inner);
  box-shadow: none;
  opacity: var(--perxis-auto-switch-opacity-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch:hover:not(.ant-5_17_0-switch-disabled) {
  background-color: var(--perxis-auto-switch-hover-background-color-inner);
  border-width: var(--perxis-auto-switch-hover-border-width-inner);
  border-color: var(--perxis-auto-switch-hover-border-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch:hover:not(.ant-5_17_0-switch-disabled):not(.ant-5_17_0-switch-checked) .ant-5_17_0-switch-handle::before {
  background-color: var(--perxis-auto-switch-handle-hover-background-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-checked {
  background-color: var(--perxis-auto-switch-checked-background-color-inner);
  border-color: var(--perxis-auto-switch-checked-border-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-checked:hover:not(.ant-5_17_0-switch-disabled) {
  background-color: var(--perxis-auto-switch-hover-checked-background-color-inner);
  border-width: var(--perxis-auto-switch-hover-checked-border-width-inner);
  border-color: var(--perxis-auto-switch-hover-checked-border-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-checked .ant-5_17_0-switch-handle {
  left: calc(100% - var(--perxis-auto-switch-handle-width-inner) - 2px);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-checked .ant-5_17_0-switch-handle::before {
  background-color: var(--perxis-auto-switch-handle-checked-background-color-inner);
  border-color: var(--perxis-auto-switch-handle-checked-border-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-checked .ant-5_17_0-switch-handle .ant-5_17_0-switch-loading-icon {
  color: var(--perxis-auto-switch-checked-loading-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch.ant-5_17_0-switch-disabled {
  opacity: var(--perxis-auto-switch-opacity-disabled-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch .ant-5_17_0-switch-handle {
  width: var(--perxis-auto-switch-handle-width-inner);
  height: var(--perxis-auto-switch-handle-height-inner);
  top: 50%;
  transform: translateY(-50%);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch .ant-5_17_0-switch-handle .ant-5_17_0-switch-loading-icon {
  color: var(--perxis-auto-switch-loading-color-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch .ant-5_17_0-switch-handle::before {
  background: var(--perxis-auto-switch-handle-background-color-inner);
  border-color: var(--perxis-auto-switch-handle-border-color-inner);
  border-radius: var(--perxis-auto-switch-handle-border-radius-inner);
  border-width: var(--perxis-auto-switch-handle-border-width-inner);
  border-style: solid;
  box-shadow: var(--perxis-auto-switch-handle-box-shadow-inner);
}
.perxis-auto-1_16_0-switch.ant-5_17_0-switch .ant-5_17_0-click-animating-node {
  display: none;
}
.perxis-auto-1_16_0-switch-label {
  --perxis-auto-typography-color-darkest: var(--perxis-auto-switch-color-inner);
  --perxis-auto-typography-main-font-family: var(--perxis-auto-switch-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-switch-font-weight-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-switch-text-transform-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-switch-letter-spacing-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-switch-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-switch-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-switch-line-height-inner);
  padding: var(--perxis-auto-switch-padding-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
